import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createBlock as _createBlock, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "first-mark text-raleway-22 w-100"
}
const _hoisted_2 = {
  key: 2,
  class: "last-mark text-raleway-14"
}

import { popupAccountTypeMessage } from "@/store/modules/User/type";
import TreeItemsComponent from "./treeItemsComponent.vue";



export default /*#__PURE__*/_defineComponent({
  __name: 'treeComponent',
  props: {
    item: {}
  },
  setup(__props: any) {

const props = __props;



return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["w-100", {
      'd-flex direction-column': Array.isArray(
        Object.values(props?.item || [])[0]
      ),
    }])
  }, [
    (!Array.isArray(props?.item))
      ? (_openBlock(), _createElementBlock("p", _hoisted_1, _toDisplayString(Object.keys(props?.item || [])[0]?.replaceAll("_", " ")), 1))
      : _createCommentVNode("", true),
    (typeof Object.values(props?.item || [])[0] === 'object')
      ? (_openBlock(), _createBlock(TreeItemsComponent, {
          key: 1,
          items: Object.values(props?.item || [])
        }, null, 8, ["items"]))
      : (_openBlock(), _createElementBlock("p", _hoisted_2, _toDisplayString((props?.item[0] || "")), 1))
  ], 2))
}
}

})